import React, { useState } from 'react'
import { useDispatch } from 'react-redux';

import RemainingTimeComponent from '@/main/components/shared/remainingTime/remainingTimeComponent';
import { getTranslateByKey, isNullUndefined, isShowControlByElementId } from '@/main/services/utils';
import { CartState } from '@/main/store/cart';
import { QuoteNoSupplierAssignedResponse } from '@/main/models/response';

import { TypeBoxCart } from '../types';
import * as S from './styles';
import { Controls } from '@/main/services/constants/constantsControl';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import UpdateIcon from '@mui/icons-material/Update';

import { quoteApi} from '@/main/api';
import { toast } from 'react-toastify';
import useAsyncModalConfirm from '@/main/components/shared/asyncModalConfirm/asyncModalConfirm';

interface IRemainingTimeShippingTable {
  cart: QuoteNoSupplierAssignedResponse | null;
  guidQuote: string;
  type?: TypeBoxCart;
  dataCart: CartState;
  loadCart: (guidQuote: string) => void;
}
function RemainingTimeShippingTable({
  cart,
  guidQuote,
  dataCart,
  loadCart,
  type = 'unaswered'
}: IRemainingTimeShippingTable) {

  const cartNoSupplierAssigned = dataCart.cartItems.dataNoSupplierAssigned;
  const cartDataUnansweredItems = dataCart.cartItems.dataUnansweredItems;

  const [isFinishedTime, setIsFinishedTime] = useState<boolean>(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [getConfirmation, ModalConfirmation] = useAsyncModalConfirm();

  function handleFinishTime() {
    setIsFinishedTime(true);
    const haveNoSupplierAndUnansweredItems = !isNullUndefined(cartNoSupplierAssigned) && !isNullUndefined(cartDataUnansweredItems);
    if (haveNoSupplierAndUnansweredItems && type === 'noSupplierAssigned') return;
    loadCart(guidQuote);
  }

function handleExpireDeadlineAnswer() {
  setIsLoadingSave(true);
  quoteApi
    .expireDeadlineAnswer(String(guidQuote))
    .then(res => {
      const resData = res.data.result;
      if (resData) {
        toast.success(getTranslateByKey('information.quoteExpiredSucessfully'));
        loadCart(guidQuote);
      }
    })
    .finally(() => setIsLoadingSave(false));;
  }  

  if (isFinishedTime || (isNullUndefined(cart) || !cart.showDeadlineAnswer)) return <></>;

  return (
    <S.ContainterRemainingTime>
      {`- ${getTranslateByKey('information.remainingTimeToExpire')}:`}
      <S.ContainterItemRemainingTime>
        <RemainingTimeComponent
          finishTime={cart.deadlineAnswer}
          onTimeFinished={handleFinishTime}
          showExpire={false}
        />
      </S.ContainterItemRemainingTime>
        {isShowControlByElementId(Controls.IdExpireDeadlineAnswer) && cart.showExpireDeadline && (
          <Tooltip title={getTranslateByKey('control.ExpireDeadlineAnswer')}>
            <IconButton
              id="id-createOrder-button-expire-deadline-answer"
              size="small"
              sx={{ ml: 1 }}
              aria-label={getTranslateByKey('control.ExpireDeadlineAnswer')}
              onClick={async () => {
                const isConfirm = await getConfirmation(getTranslateByKey('information.expirationDateConfirm'));
                if (!isConfirm) return;
                handleExpireDeadlineAnswer();
              }}>
              <UpdateIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        <ModalConfirmation />
      </S.ContainterRemainingTime>)     
}

export default RemainingTimeShippingTable